module.exports = __webpack_public_path__ + "media/video.23fd0dbb.mp4";